import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { RocketOutlined } from '@mui/icons-material';

export default function NavCard() {
  return (
    <Box sx={{ px: 1.5, pb: 1.75, pt: 0.5 }}>
      <Box
        sx={{
          background: 'linear-gradient(135deg, var(--appMainMain) 0%, var(--appMain800) 100%)',
          borderRadius: '14px',
          p: '14px 16px',
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          position: 'relative',
          overflow: 'hidden',
          // decorative circles
          '&::before': {
            content: '""',
            position: 'absolute',
            top: -20,
            right: -20,
            width: 64,
            height: 64,
            borderRadius: '50%',
            bgcolor: 'rgba(255,255,255,0.06)'
          },
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: -14,
            left: 28,
            width: 48,
            height: 48,
            borderRadius: '50%',
            bgcolor: 'rgba(255,255,255,0.04)'
          }
        }}
      >
        <Box
          sx={{
            width: 34,
            height: 34,
            borderRadius: '9px',
            flexShrink: 0,
            position: 'relative',
            zIndex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'rgba(255,255,255,0.12)',
            border: '1px solid rgba(255,255,255,0.15)'
          }}
        >
          <RocketOutlined style={{ fontSize: 16, color: '#fff' }} />
        </Box>
        <Box sx={{ flex: 1, minWidth: 0, position: 'relative', zIndex: 1 }}>
          <Typography
            sx={{
              fontSize: 10,
              fontWeight: 700,
              color: 'rgba(255,255,255,0.5)',
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              lineHeight: 1,
              mb: 0.4
            }}
          >
            Version
          </Typography>
          <Typography
            sx={{
              fontSize: 13,
              fontWeight: 700,
              color: '#fff',
              lineHeight: 1,
              letterSpacing: '-0.01em'
            }}
          >
            {import.meta.env.VITE_APP_VERSION}
          </Typography>
        </Box>
        {/* Online indicator */}
        <Box
          sx={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            bgcolor: '#5dcaa5',
            boxShadow: '0 0 0 2px rgba(93,202,165,0.3)',
            flexShrink: 0,
            position: 'relative',
            zIndex: 1
          }}
        />
      </Box>
    </Box>
  );
}
